import './bootstrap.js'; // import the bootstrap js file
// import '../css/app.css';
import '../scss/app.scss'; // import the application styles for build

// import '/node_modules/dropzone/dist/basic.css';
// import '/node_modules/dropzone/dist/dropzone.css';

import { computed, createApp, h } from 'vue';
import { createInertiaApp, usePage } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import {ZiggyVue} from 'ziggy-js';
import {Can} from './Plugins/can.js';
import {route} from 'ziggy-js';

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import 'vue-color/style.css';
import "vue3-colorpicker/style.css";

import { createPinia } from "pinia";
const pinia = createPinia();


createInertiaApp({
	title: title => `${ title } | Murray Uniforms Online`,
	resolve: (name) => resolvePageComponent(
			`./Pages/${ name }.vue`,
			import.meta.glob('./Pages/**/*.vue'),
	),
	setup({ el, App, props, plugin }) {
		const myApp = createApp({ render: () => h(App, props) })
		.use(plugin)
		.use(ZiggyVue)
		.use(pinia);
		// .mixin({
		// 	methods: { route, can }
		// });

		const permissions = computed(() => usePage().props.global.permissions);
		myApp.use(Can, permissions);

		myApp.config.globalProperties.$permissions = permissions;
		myApp.config.globalProperties.$route = route;

		myApp.component('v-select', vSelect);
		myApp.mount(el)
	},
	progress: {
		color: '#C04C36'
	}
})
